import React from "react";
import {Route, Redirect} from "react-router-dom";
import {verifyTokenValidity} from "../../../utils/TokenUtils";

export const PrivateRoute = ({component: Component, requiredRole=false, pathname, application, ...rest}) => (
    <Route
        {...rest}
        render={(props) =>
            verifyTokenValidity("atlantis", requiredRole) ? (
                <Component {...props} />
            ) : (
                <Redirect
                    to={{pathname: pathname, state: {from: props.location}}}
                />
            )
        }
    />
);
